import React from 'react';
import axios from '../providers/axios';
import { followRedirect } from '../providers/axios';

export const RECTF_TYPE_DRIVER = 1;
export const RECTF_TYPE_CAB = 2;
export const RECTF_TYPE_TOW1 = 3;
export const RECTF_TYPE_TOW2 = 4;
export const RECTF_TYPE_TOW3 = 5;
export const RECTF_TYPE_COMPANY = 6;

export const types = () => axios.get('/types/queries');
export const typeGroups = () => axios.get('/types/queries/groups');
export const status = () => axios.get('/types/queries/status');
export const statusGroups = () => axios.get('/types/queries/status/groups');
export const list = params => axios.get('/query', { params });
export const listCertificates = params => axios.get('/query/custom/certificate-report', { params });
export const preflight = data => axios.post('/query/preflight', data);
export const storeQuery = data => axios.post('/query', data);
export const renewQuery = data => axios.post('/query/requery', data);
export const followStore = followRedirect;
export const fetchQuery = id => axios.get(`/query/${id}`);
export const fetchQueryReport = id => axios.get(`/query/${id}/report`);
export const fetchQueryHistory = id => axios.get(`/query/${id}/history`);
export const rectificationFileBlob = (queryId, rectificationId) =>
  axios.get(`/query/${queryId}/rectifications/${rectificationId}/file`, { responseType: 'blob' });
export const sendRectificationFile = (queryId, type, itemId, file) => {
  const data = new FormData();

  data.set('rectification', file);
  data.set('type', type);
  data.set('itemId', itemId);

  return axios.post(`/query/${queryId}/rectifications`, data);
};

export const lastQueryFreight = data => axios.get('/freight/lastquery', data);

export const requiredFreight = data => axios.get('/freight/required', data);

export const fetchQueryFreight = (page, query) =>
  axios.get(`freight?limit=10&page=${page}&q=${query}`);

export const homologatorStatus = () => axios.get('/query/homologator');

export const overdueDriverQueries = params => axios.get('/query/overdue/drivers', { params });

export const overdueVehicleQueries = params => axios.get('/query/overdue/vehicles', { params });

export const queryCustom = () => axios.get('/query/custom/names');

export const overdueIntegratedQueries = params =>
  axios.get('/query/overdue/integrated', { params });

export const unbindDrivers = drivers => axios.post('/query/unbind/drivers', drivers);
export const unbindVehicles = vehicles => axios.post('/query/unbind/vehicles', vehicles);
export const unbindIntegrated = queries => axios.post('/query/unbind/integrated', queries);

export const requeryDrivers = drivers => axios.post('/query/requery/drivers/custom', drivers);
export const requeryVehicles = vehicles => axios.post('/query/requery/vehicles/custom', vehicles);
export const requeryIntegrated = queries => axios.post('/query/requery/integrated', queries);

export const ERROR_QUERY_IN_PROGRESS = 'query_in_progress';
export const ERROR_QUERY_INCOMPLETE = 'query_incomplete';
export const ERROR_QUERY_BLOCKED = 'query_blocked';
export const ERROR_UNREGISTERED_QUERY = 'unregistered_query';
export const ERROR_NO_HOMOLOGATOR = 'unassociated_homologator';
export const ERROR_FORBIDDEN = 'invalid_scope';
export const ERROR_QUERY_NOT_ALLOWED = 'query_not_allowed';

/* eslint-disable max-len */
export const errorMessages = {
  [ERROR_QUERY_IN_PROGRESS]: 'Já existe uma consulta com esse perfil em andamento. Por favor aguarde!',
  [ERROR_QUERY_INCOMPLETE]: 'Os dados da consulta estão incompletos, edite as informações e tente novamente.',
  [ERROR_QUERY_BLOCKED]: 'Não é possível realizar uma nova consulta, pois o prazo da última consulta realizada ainda está válida.',
  [ERROR_UNREGISTERED_QUERY]: 'Necessário Consultar Perfil para depois recadastrar!',
  [ERROR_QUERY_NOT_ALLOWED]: 'Solicitação Não Enviada para Análise - Entre em Contato com a Central AngelLira',
};

export const errors = Object.keys(errorMessages);

export const formatErrorMessage = ({ error, queryId = null }) => <>
  {errorMessages[error]}
  {queryId && <><br />Nr. da Consulta: {queryId}</>}
</>;
